export default __webpack_public_path__ + "static/media/download.6e6aa186.svg";